import { Reveal, Kicker } from "./motion";

export default function Comparison() {
  return (
    <section
      id="comparison"
      data-testid="comparison"
      className="px-6 md:px-12 py-28 md:py-40 border-t border-verlo/10"
    >
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <Kicker>The difference</Kicker>
          <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.1] text-verlo max-w-3xl">
            The old way, and the way it works now
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-24 grid md:grid-cols-2 gap-px bg-verlo/15 border border-verlo/15">
          <Reveal className="bg-paper p-8 md:p-14">
            <p className="text-xs tracking-[0.2em] uppercase text-verlo/40 mb-8">
              A traditional setup
            </p>
            <p className="font-display font-light text-2xl md:text-3xl leading-[1.5] text-verlo">
              Five products from three vendors. An EPOS that does tills, a separate app
              for stock, a payroll tool that never quite agrees with the rota, and two
              integrations held together with good intentions. Reporting lives in a
              spreadsheet someone rebuilds every Monday. When something breaks, everyone
              points at someone else, and you are the one on the phone during service.
            </p>
          </Reveal>

          <Reveal delay={0.1} className="bg-paper p-8 md:p-14">
            <p className="text-xs tracking-[0.2em] uppercase text-brass mb-8">
              Verlo
            </p>
            <p className="font-display font-light text-2xl md:text-3xl leading-[1.45] text-verlo">
              One platform. One data model, so the floor, the office and the numbers are
              always looking at the same truth. One team who understands restaurants and
              picks up when you call. Nothing to reconcile, nothing to stitch back
              together, nothing that only half connects. The business simply runs, and the
              people running it can look up.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
